__turbopack_context__.v({
  "body": "Brc20DisclaimerModal-module__dTHUZq__body",
  "cancelButton": "Brc20DisclaimerModal-module__dTHUZq__cancelButton",
  "description": "Brc20DisclaimerModal-module__dTHUZq__description",
  "icon": "Brc20DisclaimerModal-module__dTHUZq__icon",
  "title": "Brc20DisclaimerModal-module__dTHUZq__title",
});
